export default __webpack_public_path__ + "static/media/usdt_bsc.1285f3b1.svg";